// Import react libs
import { Link } from 'react-router-dom';

// Import style lib
import styled from 'styled-components';

// Import colors
import colors from '../../utils/styles/colors';

// Styled menu button
export const MenuButton = styled.button`
    /* Events */
    cursor: pointer;
    &:hover {
        filter: brightness(1.2);
    }
`;

// Styled Menu Icon
export const MenuIcon = styled.svg`
    /* Appearance */
    fill: ${colors.primaryBeige};

    /* Size */
    width: ${(props) => props.width}px;
    height: ${(props) => props.width}px;
`;

// Styled lateral menu wrapper
export const LateralMenuNav = styled.nav.withConfig({
    shouldForwardProp: (prop) => !['latMenuMaxWidth'].includes(prop),
})`
    /* Appearance */
    background-color: #fff;

    /* Element disposition */
    position: fixed;
    top: 0;
    left: 0;
    z-index: 1000;

    /* Content disposition */
    display: flex;
    flex-direction: column;
    align-items: flex-start;

    /* Size */
    height: 100%;
    width: 300px;
    max-width: ${(props) => props.latMenuMaxWidth}px;

    /* Spacing */
    padding: 20px 15px;

    /* Visual effects */
    box-shadow: 4px 0px 6px rgba(0, 0, 0, 0.1);
`;

// Styled menu items table
export const MenuTable = styled.ul`
    /* Appearance */
    list-style: none;

    /* Spacing */
    margin: 0px 30px;
`;

// Styled menu items
export const MenuItem = styled.li`
    /* Spacing */
    margin: 20px 30px;
`;

// Styled menu link
export const MenuLink = styled(Link)`
    /* Events */
    cursor: pointer;
    &:hover {
        text-decoration: underline;
    }
`;

// Styled shade overlay
export const Overlay = styled.div`
    /* Appearance */
    background: rgba(0, 0, 0, 0.5);

    /* Element disposition */
    position: fixed;
    top: 0;
    left: 0;
    z-index: 999;

    /* Size */
    width: 100%;
    height: 100%;
`;

// Styled close button
export const CloseButton = styled.button`
    /* Spacing */
    margin-bottom: 20px;

    /* Events */
    cursor: pointer;
    &:hover {
        filter: brightness(1.2);
    }
`;

// Styled Close Icon
export const CloseIcon = styled.svg`
    /* Appearance */
    fill: ${colors.primaryBeige};

    /* Size */
    width: ${(props) => props.width}px;
    height: ${(props) => props.width}px;
`;
